import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

export function LangToggle() {
  const { i18n } = useTranslation();

  const toggleLanguage = () => {
    const newLang = i18n.language === 'de' ? 'ru' : 'de';
    i18n.changeLanguage(newLang);
  };

  return (
    <Button
      onClick={toggleLanguage}
      size="small"
      variant="text"
      sx={{
        textTransform: 'uppercase',
        fontWeight: 600,
        fontSize: '0.875rem',
        minWidth: 'auto',
        padding: '4px 8px',
      }}
    >
      {i18n.language === 'de' ? 'RU' : 'DE'}
    </Button>
  );
}
